var Mock = require('mockjs');


export default {

}



// WEBPACK FOOTER //
// ./src/API/mock.js